/* eslint-disable no-restricted-syntax */
/* oxlint-disable core/no-restricted-syntax */
/**
 * Safely get the top window object (if possible).
 * Falls back to the current window if the top window is not accessible.
 */
export function getTopWindow(): Window {
  try {
    return window.top && window.location.toString() !== window.top.location.toString()
      ? window.top
      : window;
  } catch {
    // If we're in an iframe and the parent is on a different domain, we can't access it.
    // In this case we fall back to the current window. This covers the case where the app is
    // embedded in a different domain (e.g. in a different tenant) via smartlink.
    return window;
  }
}
